module.exports = __webpack_public_path__ + "img/cash_50.a6a7e66d.svg";